import React from 'react';
import classNames from 'classnames';
import { Stack } from '@fiverr-private/layout_components';
import { ModalFooterProps } from '../types';
import { useModalContext } from '../ModalContext';

import { noBorderMd, noBorderSm } from './styles.ve.css';

const ModalFooter = ({ children }: ModalFooterProps) => {
  const { centered, fullScreenBreakpoint } = useModalContext();

  return (
    <Stack
      alignItems="center"
      justifyContent={centered ? 'center' : 'flexEnd'}
      gap="3"
      padding={{ default: '6', md: '8' }}
      borderTopWidth={fullScreenBreakpoint === 'none' ? undefined : 'sm'}
      className={classNames(
        { [noBorderSm]: fullScreenBreakpoint === 'sm' },
        { [noBorderMd]: fullScreenBreakpoint === 'md' }
      )}
    >
      {children}
    </Stack>
  );
};

ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;
